export const IMPORT_STATUS = {
  NOT_FOUND: 'notfound',
  CANCELLED: 'cancelled',
  NOT_IMPORTED: 'notimported',
};
